module.exports = __webpack_public_path__ + "static/media/x-close.a5e65fbb.svg";